// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f8ed22eb","650":"d6d957a9","977":"9eced2f9"}[chunkId] + ".chunk.js";
};